import { render, staticRenderFns } from "./PrizeGrantRecord.vue?vue&type=template&id=c607f93a&scoped=true&"
import script from "./PrizeGrantRecord.vue?vue&type=script&lang=js&"
export * from "./PrizeGrantRecord.vue?vue&type=script&lang=js&"
import style0 from "./PrizeGrantRecord.vue?vue&type=style&index=0&id=c607f93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c607f93a",
  null
  
)

export default component.exports